// extracted by mini-css-extract-plugin
export default {"container":"styles_container__46CzV","box":"styles_box__YZOjz","slider":"styles_slider__jojX7"};